<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'PointItem',
})
</script>
<template>
  <Collapse.Panel :key="record.id">
    <template #header>
      <div>{{ title }}</div>
    </template>
    <Descriptions layout="vertical" :column="{ xxl: 3, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }" size="middle">
      <Descriptions.Item label="所属地区">
        <DictDisplay :value="record.positionAddress" />
      </Descriptions.Item>
      <Descriptions.Item label="涉及村/社区">
        <JtProjPointVillagesDisplay :text="record.positionAddressVillages" />
      </Descriptions.Item>
      <Descriptions.Item label="详细地址">
        {{ record.positionAddressDetail }}
      </Descriptions.Item>
      <Descriptions.Item label="地理围栏" :span="3" :contentStyle="{ display: 'block' }">
        <TMapGeofenceDisplay :value="record.positionCoordinate" />
      </Descriptions.Item>
    </Descriptions>
  </Collapse.Panel>
</template>

<script lang="ts" setup name="PointItem">
import { TMapGeofenceDisplay } from '-/Base/TMap'
import { DictDisplay } from '-/Business'
import { JtProjPointVillagesDisplay } from '-/Business/CommonDisplay'
import { Collapse, Descriptions } from 'ant-design-vue'
import { computed } from 'vue'
const props = withDefaults(
  defineProps<{
    record: ApiPoint.Item
    index?: number
  }>(),
  {
    index: 0
  }
)
const title = computed(() => `拆迁点位 ${props.index + 1}`)
</script>
